module.exports = __webpack_public_path__ + "assets/img/jiesuan.102655b3.png";